import { useQuery } from '@tanstack/react-query';
import { getProjectActivityChartData } from 'services/reactQueryservices';
import { projectActivityChartDatakey } from 'react_query/query-keys';

const useProjectActivityChartData = (division: string, district: string, upazila: string, union: string) => {
    const { data, isFetching, error } = useQuery({
        queryKey: [projectActivityChartDatakey, division, district, upazila, union],
        queryFn: () => getProjectActivityChartData(division, district, upazila, union)
    });

    return {
        data,
        isFetching,
        error
    };
}

export default useProjectActivityChartData;